import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import persistedState from 'vuex-persistedstate';

Vue.use(Vuex);

export default new Vuex.Store({
	plugins: [
		persistedState({
			paths: ['verifiedTokenEmail', 'creation.accountEmail'],
		}),
	],
	state: {
		accountId: null,
		accountPassword: null,
		isMobile: /(iPhone|iPad|Android|Mobile)/gi.test(navigator.userAgent),
		configurations: {},
		settings: null,
		thirdPartyList: [],
		inlineInput: {
			errors: {},
		},
		form: {
			errors: {},
		},
		create: {
			errors: {},
		},
		loginType: 'login',
		baseAccountAddress: `${environment.webApi}`,
		requestLoginAddress: `${environment.webApi}/login`,
		createAccountType: 'create',
		requestCreateAccountAddress: `${environment.webApi}/signup`,
		migration: {
			accountEmail: null,
			legacyLoginID: null,
			emailVerified: false,
		},
		creation: {
			accountEmail: null,
			autoLogin: null,
			passwordHash: null,
			captchaResponse: null,
		},
		healup: {
			isTPA: true,
			tpaType: null,
		},
		challengeTitle: null,
		securityQuestion: {},
		launcherLoginData: {},
		returnURL: null,
		authorizeParams: {},
		ssoParams: {},
		productId: null,
		partnerKey: null,
		middleWareUrl: null,
		optOutInfo: null,
		directReturn: null,
		channel: null,
		createdAccountEmail: null,
		verifiedTokenEmail: null,
		referrerUrl: null,
		appType: 'web',
		loading: false,
		tpaInit: {
			google: false,
			facebook: false,
		},
	},
	actions: {
		retrieveConfiguration({ commit }) {
			axios
				.get(`${environment.webApi}/v2/configurations`)
				.then((response) => response.data)
				.then((configData) => {
					commit('setConfiguration', configData);
				})
				.catch(() => {});
		},
	},
	mutations: {
		setAppType(state, payload) {
			state.appType = payload;
		},
		setVerifiedTokenEmail(state, payload) {
			state.verifiedTokenEmail = payload;
		},
		clearVerifiedTokenEmail(state) {
			state.verifiedTokenEmail = null;
		},
		setDirectReturn(state, payload) {
			state.directReturn = payload;
		},
		setLauncherLoginData(state, payload) {
			state.launcherLoginData = payload;
		},
		getOptOutInfo(state, payload) {
			state.optOutInfo = payload;
		},
		getMiddlewareUrl(state, payload) {
			state.middleWareUrl = payload;
		},
		setAccountId(state, payload) {
			state.accountId = payload;
		},
		setAccountPassword(state, payload) {
			state.accountPassword = payload;
		},
		setProductId(state, payload) {
			state.productId = payload;
		},
		setPartnerKey(state, payload) {
			state.partnerKey = payload;
		},
		getAuthorizeParams(state, payload) {
			state.authorizeParams = { ...payload };
		},
		getSsoParams(state, payload) {
			state.ssoParams = { ...payload };
		},
		setSecurityChallengeInfo(state, payload) {
			state.securityQuestion = {
				...state.securityQuestion,
				question: payload.question,
				answer: payload.answer,
			};
		},
		setChallengeTitle(state, payload) {
			state.challengeTitle = payload;
		},
		setConfiguration(state, payload) {
			state.configurations = { ...payload };
		},
		setSettingsData(state, payload) {
			state.settings = { ...payload };
		},
		setCreationData(state, payload) {
			state.creation[payload.name] = payload.value;
		},
		setMigrationData(state, payload) {
			state.migration[payload.name] = payload.value;
		},
		changeLoginType(state, payload) {
			state.loginType = payload;
		},
		changeLoginAddress(state, payload) {
			state.requestLoginAddress = payload;
		},
		changeCreateAccountType(state, payload) {
			state.createAccountType = payload;
		},
		changeCreateAccountAddress(state, payload) {
			state.requestCreateAccountAddress = payload;
		},
		setData(state, payload) {
			state.checkoutData = { ...payload };
		},
		setInputValidationError(state, payload) {
			state.inlineInput.errors = {
				...state.inlineInput.errors,
				[payload.field]: payload.msgs,
			};
		},
		setFormError(state, payload) {
			state.form.errors = { ...state.form.errors, code: payload.field };
		},
		setLegacyLoginID(state, payload) {
			state.legacyLoginID = payload;
		},
		clearValidationError(state, payload) {
			Vue.delete(state.inlineInput.errors, payload.field);
		},
		getThirdPartyList(state, payload) {
			state.thirdPartyList = [...payload];
		},
		setReturnURL(state, payload) {
			state.returnURL = payload;
		},
		setChannel(state, payload) {
			state.channel = payload;
		},
		setReferrerUrl(state, payload) {
			state.referrerUrl = payload;
		},
		setLoading(state, payload) {
			state.loading = payload;
		},
		setTpaInit(state, payload) {
			if (typeof payload !== 'object') return;
			state.tpaInit = Object.assign({}, state.tpaInit, payload);
		},
	},
});



// WEBPACK FOOTER //
// ./src/store/index.js